module.exports = __webpack_public_path__ + "static/media/triangolo_giallo_osteria.e201755a.svg";